export default __webpack_public_path__ + "static/Austin-Medium-5e179a503b8d92b5c66b0bbf4cdae646.woff2";